export default __webpack_public_path__ + "img/logo-ts.7211e002.png";